import React from 'react';
import {
  Row, Col,
} from 'react-bootstrap';
import success from 'assets/img/mobile-exito@3x.png';

function SuccessComponent() {
  return (
    <Row className="">
      <Col md className="mt-5 card--light d-flex align-items-center justify-content-center flex-column">
        <img src={success} alt="Your card was saved sucessfully!" style={{ height: 150 }} />
        <h1 className="text--green2">¡Método de pago añadido con éxito!</h1>
        <p>Enhorabuena, tu método de pago ha sido añadido con éxito</p>
      </Col>
    </Row>
  );
}

export default SuccessComponent;
